import Cookies from "universal-cookie";

const cookies = new Cookies();
// const auth=cookies.get('sidd').lenght
let initialState = ''

if(typeof(cookies.get('sidd')) != "undefined" && cookies.get('sidd') !== null ){
  // initialState = [cookies.get('usidd'),cookies.get('sidd')];
  initialState = [cookies.get('usidd'),cookies.get('sidd'),cookies.get('access_level')];

}





export default function auth(state = initialState, action) {
 if (action.type === 'auth_on') {
      // console.log(action.trackdel)
      return action.login

  }
  else if (action.type === 'auth_off') {
        console.log(action.trackdel)
        return ''
  }
  return state;
}
